<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <component :is="resolvedComponent" v-if="resolvedComponent" />
  <div v-else>
    <v-container>
      <v-row>
        <v-col>
          <v-alert type="error">
            Invalid or missing referrer. Please contact support.
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'LoginDialogLoader',
  computed: {
    resolvedComponent() {
      // Get referrer from query param
      let referrer = this.$route.query.referrer;

      // Sanitize referrer (lowercase, allow only a-z, 0-9, and hyphens)
      if (referrer) {
        referrer = referrer.toLowerCase().replace(/[^a-z0-9-]/g, '');
      }

      // Default to trade-advisory if no referrer
      if (!referrer) {
        referrer = 'trade-advisory';
      }

      // Build component name
      const componentName = `login-dialog-${referrer}`;

      try {
        // Use require.context to create a map of available login dialogs
        const loginDialogs = require.context(
          '@/components/application-level/',
          false,
          /^\.\/login-dialog-.*\.vue$/
        );

        // Try to find the component
        const componentPath = `./${componentName}.vue`;
        
        if (loginDialogs.keys().includes(componentPath)) {
          return loginDialogs(componentPath).default;
        }

        // Fallback to trade-advisory if component not found
        console.warn(
          `Login dialog for referrer "${referrer}" not found. Falling back to trade-advisory.`
        );
        const fallbackPath = './login-dialog-trade-advisory.vue';
        if (loginDialogs.keys().includes(fallbackPath)) {
          return loginDialogs(fallbackPath).default;
        }
      } catch (error) {
        console.error('Error loading login dialog:', error);
      }

      return null;
    },
  },
};
</script>
